<div class="dtf-accountdetails">
  <div class="dtf-alertpage"></div>
  <div *ngIf="(this.bodyLoaded)" class="mbfs-payoff-quote-spinner">

    <!--Default page to load while waiting for Redirection to Classic-->
    <section class="mbfs-home-hero"
      style="background-image: url(/static/assets/img/dtf-assets/images/redesign/mbfs_top_image_and_tint.jpg);">
      <section class="mbfs-home-hero__header">
        <h2 class="mbfs-home-hero__header-subtitle">
          {{ 'LoaderPages.BannerHeader' | translate }}
        </h2>
        <p class="mbfs-home-hero__header-text-demi">
          {{ 'LoaderPages.Loading' | translate }}
        </p>

        <!--Spinner-->
        <div class="mbfs-loading-spinner-overlay"></div>
        <div class="mbfs-loading-spinner"> </div>
      </section>
    </section>
  </div>

  <div class="container_dashboard">
    <h4 class="dtfbrochures__header_dark">{{ 'Amortization.Header' | translate }}</h4>
    <div class="dtfbrochures__containerlong">
      <div class="row4">
        <div class="dynamicflexbox">
          <section class="section">
            <div class="section__item section__item--start">
              <h4 class="dtfbrochures__header5">{{ 'Dashboard.NumAccounts' | translate }}</h4>
              <h3 class="dtfbrochures__header6">{{this.recAccCount}}</h3>
            </div>
            <div class="section__item section__item--end">
              <h4 class="dtfbrochures__header5">{{ 'Dashboard.CurrentDue' | translate }}</h4>
              <h3 class="dtfbrochures__header6">${{this.totalDue}}</h3>
            </div>
          </section>
        </div>
      </div>
    </div>


    <div class="padding-main-divcls" id="agrrement-section">
      
      <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
        <!--Spinner on Login Load-->
        <div class="demo-container">
          <span>{{ 'Invoice.Loading' | translate }}</span>
          <div class="progress-bar">
            <div class="progress-bar-value"></div>
          </div>
        </div>
        <br>
      </div>

      <div *ngIf="(this.loading)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
        <!--Spinner on Login Load-->
        <div class="demo-container">
          <span>{{ 'Invoice.Loading1' | translate }}</span>
          <div class="progress-bar">
            <div class="progress-bar-value"></div>
          </div>
        </div>
        <br>
      </div>

      <div class="tile">
        <div [hidden]="AmortSelected || !loanAccounts">
          <div style="float: left;">
            <button (click)="downloadAll()" class="mbfs-button">{{ 'AccountDetails.downloadpdf' | translate }}</button>
          </div>
          <div class="accountflex">
            <h1 class="mercedes-me-login__column-headline2"></h1>
            <mat-form-field class="example-form-field" appearance="outline">
              <mat-label>{{ 'AccountDetails.Search' | translate }}</mat-label>
              <input matInput (keyup)="applyFilter($event)" placeholder="Account Number or Status" #input type="text"
                [(ngModel)]="value">
              <img matSuffix class="example-form-img"
                src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
            </mat-form-field>
          </div>
          <div class="row">
            <div class="col">
              <p *ngIf="!isFrench">Please select one account</p>
              <p *ngIf="isFrench">Veuillez sélectionner un compte</p>
            </div>
          </div>
          <mat-table [dataSource]="accountdataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
            <!--US/EN Table loading-->
            <ng-container matColumnDef="{{column.name}}"
              *ngFor="let column of accountinitColumns; last as isLast; first as isFirst;">
              <div *ngIf="isFirst">
                <mat-checkbox  [ngClass]="{'white-border': !isChecked}" (change)="$event ? masterToggle() : null" [checked]="selection.hasValue()&& isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()">
                </mat-checkbox>
              </div>
              <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef>
                <div *ngIf="!isFrench"> {{column.display}}</div>
                <div *ngIf="isFrench"> {{column.displayFR}}</div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <div *ngIf="isFirst">
                  <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(element) : null"
                    [checked]="selection.isSelected(element)">
                  </mat-checkbox>
                </div>
                <span class="mobile-label">
                  <div *ngIf="!isFrench"> {{column.display}} :</div>
                  <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                </span>
                <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
                  {{element[column.name] | currency:'USD':true:'1.2-2'}}
                </div>
                <div *ngIf="column.dispFormat=='contract'"> <!--Formats Contract String Columns-->
                  {{element[column.name]}}
                </div>
                <div *ngIf="column.dispFormat==''"> <!--Formats String Columns-->
                  {{element[column.name]}}
                </div>
                <div *ngIf="column.dispFormat=='date'"> <!--Formats date Columns-->
                  {{element[column.name] | date:'MM/dd/yyyy'}}
                </div>
              </mat-cell>
            </ng-container>
      
            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="accountDetailsRes">
              <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                [attr.colspan]="accountdisplayedColumns.length">
              </mat-cell>
            </ng-container>
      
      
            <mat-header-row *matHeaderRowDef="accountdisplayedColumns"></mat-header-row>
            <mat-row *matRowDef="let element; columns: accountdisplayedColumns;" class="example-element-row"
              [class.example-expanded-row]="accountDetailsRes === element"
              (click)="accountDetailsRes = accountDetailsRes === element ? null : element">
            </mat-row>
            <mat-row *matRowDef="let row; columns: ['accountDetailsRes']" class="example-detail-row"></mat-row>
      
            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter "{{input.value}}"</td>
              <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                "{{input.value}}"</td>
            </tr>
      
          </mat-table>
          <br>
          <button type="submit" [disabled]="!this.tableLoaded" (click)="onAmortSelected()" class="mbfs-button">{{
            'LoginModal.Continue' | translate }}</button>
            <mat-paginator [pageSizeOptions]="[10,25,100]"></mat-paginator>
        </div>
     

    <div *ngIf="AmortSelected && loanAccounts">
      <button type="submit"(click)="amortRedirect($event)" class="mbfs-button">{{ 'LoginModal.Return' | translate }}</button><br>

      <b *ngIf="!isFrench"> Amortization Schedules are available for loan contracts only.</b>
      <b *ngIf="isFrench"> Les tableaux d'amortissement sont disponibles uniquement pour les contrats de prêt.</b>

      <p *ngIf="!isFrench"><label> Selected Account: {{contractNumber}}001</label></p>
      <p *ngIf="isFrench"><label> Compte sélectionné: {{contractNumber}}001</label></p>
      <!--Mat Table for US / CA-->
      <mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8"  matSort>
        <!--US/EN Table loading-->
        <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initColumns; last as isLast">
          <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef style="justify-content: center; font-size: larger;">
            <div *ngIf="!isFrench"> {{column.display}}</div>
            <div *ngIf="isFrench"> {{column.displayFR}}</div>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" style="justify-content: center;">
            <span class="mobile-label">
              <div *ngIf="!isFrench"> {{column.display}} :</div>
              <div *ngIf="isFrench"> {{column.displayFR}} :</div>
            </span>
            <div *ngIf="column.dispFormat=='currency'">
              <!--Formats Currency Columns-->
              {{element[column.name] | currency:'USD':true:'1.2-2'}}
            </div>
            <div *ngIf="column.dispFormat==''">
              <!--Formats String Columns-->
              {{element[column.name]}}
            </div>
            <div *ngIf="column.dispFormat=='date'">
              <!--Formats date Columns-->
              {{element[column.name] | date:'MM/dd/yyyy'}}
            </div>
          </mat-cell>
        </ng-container>

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="amortRes">
          <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
            [attr.colspan]="displayedColumns.length">
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
          [class.example-expanded-row]="amortRes === element" (click)="amortRes = amortRes === element ? null : element">
        </mat-row>
        <mat-row *matRowDef="let row; columns: ['amortRes']" class="example-detail-row"></mat-row>
      
      </mat-table>
      <!-- <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator> -->

    </div>

      <div *ngIf="!loanAccounts && dbLoaded">
        <b *ngIf="!isFrench"> Amortization Schedules are available for loan contracts only.</b>
        <b *ngIf="isFrench"> Les tableaux d'amortissement sont disponibles uniquement pour les contrats de prêt.</b>
        <div class="row align-items-center">
          <div class="col">
          <div class="accountflex">
            <h1 class="mercedes-me-login__column-headline2">{{ 'AccountDetails.Contracts' | translate }}</h1>
          </div>
        </div>
        </div>  
        <p *ngIf="!isFrench"> No active loan account(s) available</p>
        <p *ngIf="isFrench"> Aucun compte de prêt actif disponible</p>
       
        
      </div>
  </div>
  <footer id="mbfs-footer" *ngIf="AmortSelected">
    <div role="contentinfo">
      <p class="paragraph1">
        {{ 'Amortization.Disclaimer3' | translate }}
      </p>
    </div>
  
    <div role="contentinfo" style="text-align:end;">
      <button
        type="button"
        class="mbfs-button"
        (click)="exportTable()">
        {{ 'Amortization.Download' | translate }}
      </button>
    </div>
  </footer>
</div>
</div>
</div>